<template>
  <v-navigation-drawer
      :width="drawerWidth"
      absolute
      class="nav fix-menu"
      permanent
      touchless
  >
    <v-card :class="{primary:$router.history.current.path==='/logistic_cal'}" class="pa-2" outlined tile
            @click="onClickMenu('logistic_cal')">
      คำนวน
    </v-card>
    <v-card :class="{primary:$router.history.current.path==='/logistic_report'}" class="pa-2" outlined tile
            @click="onClickMenu('logistic_report')">
      รายงาน
    </v-card>
    <v-card :class="{primary:$router.history.current.path==='/trucks'}" class="pa-2" outlined tile
            @click="onClickMenu('trucks')">
      รถ
    </v-card>
    <v-card :class="{primary:$router.history.current.path==='/logistic_setting'}" class="pa-2" outlined tile
            @click="onClickMenu('logistic_setting')">
      ตั้งค่า
    </v-card>
    <v-card :class="{primary:$router.history.current.path==='/provinces'}" class="pa-2" outlined tile
            @click="onClickMenu('provinces')">
      ตั้งค่าที่พัก
    </v-card>
    <v-card :class="{primary:$router.history.current.path==='/routes'}" class="pa-2" outlined tile
            @click="onClickMenu('routes')">
      ตั้งค่าเส้นทาง
    </v-card>
    <v-card :class="{primary:$router.history.current.path==='/line_stream'}" class="pa-2" outlined tile
            @click="onClickMenu('line_stream')">
      ตั้งค่า notify
    </v-card>

    <v-btn
        absolute
        class="primary"
        right style="width: 150px;left: 50%;bottom: 75px;margin-left: -75px" @click="createRoute()">สร้างทริป
    </v-btn>
  </v-navigation-drawer>
</template>

<style lang="scss" scoped>
.theme--light .primary {
  color: #FFFFFF !important;
}
</style>

<script lang="ts">

import {Route, RouteConst} from '@/models/Route'
import router from '@/router'
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  components: {},
})
export default class Menu extends Vue {

  @Prop() drawerWidth: number
  @Prop() currentMenu: string

  // @Prop() onClickMenu: Function

  onClickMenu(path: string) {
    router.push('/' + path)
  }

  createRoute() {
    var object = new Route()
    object.id = -1
    object.status = RouteConst.STATUS_DRAFT
    this.$root.$emit('openRoute', {route: object})
  }
}

</script>
